import dynamic from 'next/dynamic';
import { useState, type FunctionComponent } from 'react';

import { InfoOutline as InfoIcon } from '@/core/tamagoshi/icons/InfoOutline';
import { Text } from '@/core/tamagoshi/Text/Text';
import { H2 } from '@/core/tamagoshiv2/components/Typography/Typography';
import { RecommendationPlaylist } from '@/productDiscovery/Recommendation/interfaces/productRecommendation';
import { sponsoredRecommendationSubtitle } from '@/productDiscovery/SponsoredProductRecommendation/translations';
import { SponsorInfoModalProps } from '@/productDiscovery/SponsorInformations/SponsorInfoModal/SponsorInfoModal';

import styles from './PlaylistTitleSponsored.module.scss';

const DynamicSponsorInfoModal = dynamic<SponsorInfoModalProps>(() =>
  import(
    '@/productDiscovery/SponsorInformations/SponsorInfoModal/SponsorInfoModal'
  ).then((imports) => imports.SponsorInfoModal),
);

interface Props {
  playlist: RecommendationPlaylist;
  text?: string;
}

export const PlaylistTitleSponsored: FunctionComponent<Props> = ({
  text,
  playlist,
}) => {
  const [modalDisplayed, setModalDisplayed] = useState(false);

  const sponsorData = playlist.products.map((product) => ({
    id: Number(product.productId),
    title: product.title,
    imageUrl: product.imageFullpath,
    advertiser: product.sellerName,
    sponsor:
      product.adPayer === 'SELLER' ? product.sellerName : product.brandName,
  }));

  const showModal = () => {
    setModalDisplayed(true);
  };

  const hideModal = () => {
    setModalDisplayed(false);
  };

  return (
    <div className={styles.wrapper}>
      {<H2 variant="h3">{text}</H2>}
      {playlist.numberSPDisplay === playlist.products.length && (
        <>
          <Text
            role="button"
            type="small"
            className={styles.sponsoredSubtitle}
            onClick={showModal}
          >
            {sponsoredRecommendationSubtitle}
            <InfoIcon className={styles.infoIcon} fontSize={16} />
          </Text>
          {modalDisplayed && (
            <DynamicSponsorInfoModal hideModal={hideModal} data={sponsorData} />
          )}
        </>
      )}
    </div>
  );
};
